import { useState } from 'react'
import { Button, ButtonGroup } from 'reactstrap'
import { request } from '../../../Redux/Sagas/requests/api'
import { useDispatch } from 'react-redux'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import './reportDownloadButtons.scss'

/**
 * Queue spreadsheet / PDF into Downloads (same as CMS export / grid:export cron).
 * @param {{ exportUrl: string, params?: object, fileBaseName?: string }} props
 */
const ReportDownloadButtons = ({ exportUrl, params = {} }) => {
  const dispatch = useDispatch()
  const [busy, setBusy] = useState(null)

  const queueExport = (format) => {
    setBusy(format)
    request(exportUrl, 'GET', {}, {}, { ...params, format })
      .then((res) => {
        setBusy(null)
        if (!res || res.status >= 400 || res?.data?.success === false) {
          dispatch(
            setNotification({
              type: 'error',
              message: res?.data?.message || 'Export failed',
            })
          )
          return
        }
        dispatch(
          setNotification({
            type: 'success',
            message: res?.data?.message || 'Check download process in download section.',
          })
        )
        dispatch(fetchUpdateApiData(false))
      })
      .catch(() => {
        setBusy(null)
        dispatch(setNotification({ type: 'error', message: 'Export failed' }))
      })
  }

  return (
    <ButtonGroup size='sm' className='mr-2 report-download-buttons'>
      <Button outline disabled={!!busy} className='report-download-btn' onClick={() => queueExport('xlsx')}>
        {busy === 'xlsx' ? 'Queuing…' : 'Spreadsheet'}
      </Button>
      <Button outline disabled={!!busy} className='report-download-btn' onClick={() => queueExport('pdf')}>
        {busy === 'pdf' ? 'Queuing…' : 'PDF'}
      </Button>
    </ButtonGroup>
  )
}

export default ReportDownloadButtons
